<template>
  <card-modal :app-bar="false" :action="$store.getters.storeOnline.status">
    <template v-slot:header>
      <v-app-bar
        absolute
        color="white"
        shrink-on-scroll
        :height="heightHeader"
        elevation="1"
        :fade-img-on-scroll="true"
        elevate-on-scroll
        scroll-target="#scrolling"
        class="modal-height-bar"
      >
        <template v-slot:img="{ props }">
          <v-container
            v-if="product.images.length > 0"
            fluid
            fill-height
            pa-0
            ma-0
            class="test_yellow"
          >
            <v-row no-gutters class="fill-height">
              <v-img
                v-bind="props"
                :src="product.images[0].url"
                style="image-rendering: optimizeSpeed"
                cover
                position="center"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular indeterminate color="primary" />
                  </v-row>
                </template>
              </v-img>
            </v-row>
          </v-container>
        </template>
        <v-col cols="auto" style="margin-top: -11px">
          <v-app-bar-title v-if="!isVisible">
            <span class="modal-title-bar" v-text="product.name" />
          </v-app-bar-title>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto">
          <slot name="close" />
        </v-col>
      </v-app-bar>
    </template>
    <template v-slot:body>
      <v-row
        no-gutters
        justify="start"
        :class="{ 'details-content': product.images.length }"
      >
        <v-col v-observe-visibility="visibilityChanged" cols="12">
          <p
            class="modal-title"
            :class="{ 'pt-5': product.images.length === 0 }"
            v-text="product.name"
          />
        </v-col>
        <v-col cols="12">
          <span
            v-if="product.oldPrice"
            class="modal-price old-price pr-3"
            v-text="$appFormatters.formatMoney(product.oldPrice)"
          />
          <span
            class="modal-price"
            v-text="$appFormatters.formatMoney(price)"
          />
        </v-col>
        <!-- Pickup date information - Alert at top -->
        <v-col
          v-if="product.requiredPickupDateFrom || shouldShowAvailableFrom"
          cols="12"
          class="mt-3 mb-3"
        >
          <v-alert type="info" dense outlined>
            <div class="pickup-date-info">
              <strong class="pickup-date-title">{{
                $t("discovery.product_info")
              }}</strong>
            </div>
            <div v-if="product.requiredPickupDateFrom" class="mt-2">
              <p class="pickup-date-text mb-1">
                <strong>{{ $t("discovery.available_between") }}:</strong>
                {{ formatDate(product.requiredPickupDateFrom) }} -
                {{ formatDate(product.requiredPickupDateTo) }}
              </p>
            </div>
            <div v-if="shouldShowAvailableFrom" class="mt-1">
              <p class="pickup-date-text mb-0">
                <strong>{{ $t("discovery.available_for_order_from") }}:</strong>
                {{ formatDate(product.availableForOrderFrom) }}
              </p>
            </div>
          </v-alert>
        </v-col>
        <v-col cols="12">
          <span class="modal-description" v-text="product.description" />
        </v-col>
        <v-col v-if="product.productVariation.length > 0" cols="12">
          <v-divider class="mt-4" />
        </v-col>
        <VariationsComponent
          v-model="selectVariation"
          :datas="product.productVariation"
        />
        <AddonsComponent v-model="selectAddons" :datas="product.groupAddons" />
      </v-row>
    </template>
    <template v-slot:actions>
      <v-col
        cols="12"
        sm="5"
        lg="5"
        :class="$vuetify.breakpoint.xsOnly ? 'pb-1 mb-1' : ''"
      >
        <v-card elevation="10" rounded="xl" class="button-actions">
          <v-text-field
            v-model="form.productQty"
            type="number"
            :label="$t('general.quantity')"
            readonly
            outlined
            dense
            class="input-details-disable input-centered-counter"
          >
            <template v-slot:prepend>
              <v-btn icon :disabled="form.productQty < 2" @click="decrement">
                <v-icon v-text="'mdi-minus-circle-outline'" />
              </v-btn>
            </template>
            <template v-slot:append-outer>
              <v-btn icon @click="increment">
                <v-icon v-text="'mdi-plus-circle-outline'" />
              </v-btn>
            </template>
          </v-text-field>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        sm="7"
        lg="7"
        :class="$vuetify.breakpoint.xsOnly ? 'pt-0 mt-0' : ''"
      >
        <v-container fluid fill-height>
          <v-row align-content="center" class="fill-height">
            <v-btn
              :disabled="$store.getters.addonsProductErrors > 0"
              color="primary"
              width="100%"
              rounded
              elevation="10"
              :loading="isLoading"
              class="d-flex justify-space-between button-actions"
              @click="addToCart"
            >
              <div>
                <span v-text="$t('discovery.add_to_order')" />
              </div>
              <div>
                <span v-text="$appFormatters.formatMoney(totalPrice)" />
              </div>
            </v-btn>
          </v-row>
        </v-container>
      </v-col>
    </template>
  </card-modal>
</template>
<script>
import VariationsComponent from "./VariationsComponent.vue";
import AddonsComponent from "./AddonsComponent.vue";

export default {
  name: "ModalProductDetails",
  components: {
    VariationsComponent,
    AddonsComponent,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isVisible: true,
    isLoading: false,
    selectVariation: null,
    selectAddons: [],
    form: new Form({
      storeId: null,
      productId: null,
      productQty: 1,
      sessionId: null,
    }),
  }),
  computed: {
    heightHeader: function () {
      if (
        this.$vuetify.breakpoint.xs ||
        (this.$vuetify.breakpoint.sm && window.innerWidth > 700)
      ) {
        return this.product.images.length > 0 ? 200 : 70;
      } else {
        return this.product.images.length > 0 ? 250 : 70;
      }
    },
    totalPriceAddons: {
      get() {
        let total = 0;
        if (this.selectAddons.length > 0) {
          total = this.selectAddons.reduce(function (total, currentValue) {
            return total + parseFloat(currentValue.subtotal);
          }, 0);
          return total.toFixed(2);
        } else {
          return 0;
        }
      },
      set(val) {
        return val;
      },
    },
    totalPrice: {
      get() {
        let subTotal =
          parseFloat(this.price) + parseFloat(this.totalPriceAddons);
        let total = this.form.productQty * subTotal;
        return total.toFixed(2);
      },
      set(val) {
        return val;
      },
    },
    price: {
      get() {
        return this.selectVariation
          ? this.selectVariation.price
          : parseFloat(this.product.price).toFixed(2);
      },
      set(val) {
        return val;
      },
    },
    shouldShowAvailableFrom: function () {
      if (
        !this.product.availableForOrderFrom ||
        !this.product.requiredPickupDateFrom
      ) {
        return false;
      }

      const availableFrom = new Date(this.product.availableForOrderFrom);
      const pickupFrom = new Date(this.product.requiredPickupDateFrom);
      const pickupTo = new Date(this.product.requiredPickupDateTo);

      availableFrom.setHours(0, 0, 0, 0);
      pickupFrom.setHours(0, 0, 0, 0);
      pickupTo.setHours(0, 0, 0, 0);

      // Only show if availableForOrderFrom is between requiredPickupDateFrom and requiredPickupDateTo
      return availableFrom >= pickupFrom && availableFrom <= pickupTo;
    },
  },

  created() {
    const self = this;
    self.form.storeId = self.$store.getters.storeInfo.id;
    self.form.productId = self.product.id;
    self.form.sessionId = self.$store.getters.guestSessionId;
  },

  beforeMount() {
    this.$store.dispatch("discovery/set_AddosErrorsInit");
  },
  methods: {
    increment: function () {
      const self = this;
      self.form.productQty = parseInt(self.form.productQty, 10) + 1;
    },
    decrement: function () {
      const self = this;
      self.form.productQty = parseInt(self.form.productQty, 10) - 1;
    },
    visibilityChanged: function (isVisible) {
      this.isVisible = isVisible;
    },
    addToCart: async function () {
      const self = this;
      self.isLoading = true;
      if (self.selectVariation) {
        self.form["productVariationId"] = self.selectVariation.id;
      }
      if (self.selectAddons.length > 0) {
        self.form["shoppingCartDetails"] = [];
        self.selectAddons.map((item) => {
          self.form.shoppingCartDetails.push({
            productSubAddonPivotId: item.productSubAddonPivotId,
            subAddonQty: item.subAddonQty,
          });
        });
      }
      const { data } = await self.form.post("/app/orders/shopping/cart");
      if (!self.form.sessionId) {
        self.$store.dispatch("guest/setSessionId", data.data.sessionId);
      }
      if (this.$vuetify.breakpoint.mdAndUp) {
        Toast.fire({
          icon: "success",
          title: data.message,
        });
      }
      this.$store.dispatch("cart/setLoad");

      // self.$store.dispatch("loading/done");
      self.isLoading = false;
      this.$emit("input", false);
    },
    formatDate: function (dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("da-DK", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.details-content {
  padding-top: 210px;
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .details-content {
    padding-top: 140px;
  }
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .details-content {
    padding-top: 140px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 999px) and (orientation: landscape) {
  .details-content {
    padding-top: 140px;
  }
}

.pickup-date-info {
  margin-bottom: 4px;
}

.pickup-date-title {
  font-weight: 600;
  font-size: 0.95rem;
}

.pickup-date-text {
  font-size: 0.9rem;
  margin: 0;
  line-height: 1.5;
}
</style>
